import { observable } from 'mobx';
import _isEmpty from 'lodash/isEmpty';

import { clone } from 'utils';
import objectDifference from 'utils/objectDifference';

class TradingVenuesCollection extends observable.map {
  backedUpValues = new Map();

  constructor() {
    super();

    this.isDirty = () => {
      const changes = this.getChanges();

      return _isEmpty(changes);
    };

    this.commit = function() {
      this.backedUpValues = clone(this.toJS());
    };

    this.getChanges = function() {
      return objectDifference(this.toJS(), this.backedUpValues);
    };
  }
}

export { TradingVenuesCollection };



// WEBPACK FOOTER //
// ./src/stores/TradingVenuesCollection.js